function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { getDefaultElementPosition, getDefaultElementSize } from '@bydesign-ui/hooks';
import { getDefaultMousePos } from '../../../models/drag';
import { Emitter } from '@bydesign-ui/hooks';
export var ScheduleMask = function (_Emitter) {
  _inherits(ScheduleMask, _Emitter);

  var _super = _createSuper(ScheduleMask);

  function ScheduleMask(root) {
    var _this;

    _classCallCheck(this, ScheduleMask);

    _this = _super.call(this);
    _this.boxRect = getDefaultElementPosition();
    _this.startPos = getDefaultMousePos();
    _this.endPos = getDefaultMousePos();
    _this.colSize = getDefaultElementSize();
    _this.dragging = false;
    _this.maskRelativeRect = null;
    _this.root = root;
    return _this;
  }

  _createClass(ScheduleMask, [{
    key: "updateBoxRect",
    value: function updateBoxRect(rect) {
      this.boxRect = rect;
      this.updateColSize();
    }
  }, {
    key: "updateColSize",
    value: function updateColSize() {
      var divider = this.root.getDivider();
      var datasource = this.root.getDatasource();
      var rowNum = datasource.length;
      var colNum = divider * 24;
      var _this$boxRect = this.boxRect,
          width = _this$boxRect.width,
          height = _this$boxRect.height;

      if (!rowNum) {
        this.colSize = getDefaultElementSize();
        return;
      }

      this.colSize = {
        width: width / colNum | 0,
        height: height / rowNum | 0
      };
      this.emit('repaint');
    }
  }, {
    key: "getColSize",
    value: function getColSize() {
      return this.colSize;
    }
  }, {
    key: "updateStartPos",
    value: function updateStartPos(pos) {
      if (this.root.getDisabled()) {
        this.dragging = false;
        return;
      }

      this.dragging = true;
      this.startPos = pos;
    }
  }, {
    key: "updateEndPos",
    value: function updateEndPos(pos) {
      if (this.root.getDisabled()) {
        this.dragging = false;
        return;
      }

      this.endPos = pos;
      this.calcMaskRect();
      this.emit('repaint');
    }
  }, {
    key: "stopDrag",
    value: function stopDrag(endPos) {
      this.dragging = false;

      if (this.root.getDisabled()) {
        return;
      }

      this.endPos = endPos;

      if (endPos.clientX < this.boxRect.left || endPos.clientX > this.boxRect.right || endPos.clientY < this.boxRect.top || endPos.clientY > this.boxRect.bottom) {
        this.emit('repaint');
        return;
      }

      this.calcMaskRect();
      this.calcRegionValue();
    }
  }, {
    key: "getDragging",
    value: function getDragging() {
      return this.dragging;
    }
  }, {
    key: "getMaskRelativeRect",
    value: function getMaskRelativeRect() {
      return this.maskRelativeRect;
    }
  }, {
    key: "calcMaskRect",
    value: function calcMaskRect() {
      var _this$boxRect2 = this.boxRect,
          boxLeft = _this$boxRect2.left,
          boxTop = _this$boxRect2.top,
          boxRight = _this$boxRect2.right,
          boxBottom = _this$boxRect2.bottom;

      var _this$calcRegionRect = this.calcRegionRect(),
          regionLeft = _this$calcRegionRect.left,
          regionTop = _this$calcRegionRect.top,
          regionRight = _this$calcRegionRect.right,
          regionBottom = _this$calcRegionRect.bottom;

      var _this$colSize = this.colSize,
          width = _this$colSize.width,
          height = _this$colSize.height;

      if (!width || !height) {
        this.maskRelativeRect = null;
        return;
      }

      var left = Math.max(regionLeft - boxLeft, 0);
      var top = Math.max(regionTop - boxTop, 0);
      var right = Math.max(boxRight - regionRight, 0);
      var bottom = Math.max(boxBottom - regionBottom, 0);
      this.maskRelativeRect = {
        left: left - left % width,
        top: top - top % height,
        right: right - right % width,
        bottom: bottom - bottom % height
      };
    }
  }, {
    key: "calcRegionRect",
    value: function calcRegionRect() {
      var _this$startPos = this.startPos,
          startClientX = _this$startPos.clientX,
          startClientY = _this$startPos.clientY;
      var _this$endPos = this.endPos,
          endClientX = _this$endPos.clientX,
          endClientY = _this$endPos.clientY;
      var left = Math.min(startClientX, endClientX);
      var top = Math.min(startClientY, endClientY);
      var width = Math.abs(startClientX - endClientX);
      var height = Math.abs(startClientY - endClientY);
      return {
        left: left,
        top: top,
        right: left + width,
        bottom: top + height,
        width: width,
        height: height
      };
    }
  }, {
    key: "calcRegionValue",
    value: function calcRegionValue() {
      var datasource = this.root.getDatasource();
      var len = datasource.length;
      var rowNum = this.root.getDivider() * 24;
      var _this$colSize2 = this.colSize,
          width = _this$colSize2.width,
          height = _this$colSize2.height;

      if (!width || !height || !len || !this.maskRelativeRect) {
        return;
      }

      var _this$maskRelativeRec = this.maskRelativeRect,
          maskLeft = _this$maskRelativeRec.left,
          maskTop = _this$maskRelativeRec.top,
          maskRight = _this$maskRelativeRec.right,
          maskBottom = _this$maskRelativeRec.bottom;
      var value = [];
      var topOffset = Math.round(maskTop / height);
      var bottomOffset = Math.round(maskBottom / height);
      var leftOffset = Math.round(maskLeft / width);
      var rightOffset = Math.round(maskRight / width);

      for (var i = topOffset; i < len - bottomOffset; i++) {
        var label = datasource[i];
        var val = [];

        for (var j = leftOffset; j < rowNum - rightOffset; j++) {
          val.push(j);
        }

        value.push({
          label: label,
          value: val
        });
      }

      this.root.setValue(value);
    }
  }]);

  return ScheduleMask;
}(Emitter);